import SVG from 'react-inlinesvg';

import type { StaticImageData } from 'next/image';
import type { Props as InlineSVGProps } from 'react-inlinesvg';

interface CoreIconProps {
  src: InlineSVGProps['src'] | StaticImageData;
  width?: InlineSVGProps['width'];
  height?: InlineSVGProps['height'];
  className?: InlineSVGProps['className'];
  color?: InlineSVGProps['color'];
  onClick?: InlineSVGProps['onClick'];
  style?: InlineSVGProps['style'];
  tabIndex?: InlineSVGProps['tabIndex'];
}

const DEFAULT_WIDTH = 24;
const DEFAULT_HEIGHT = 24;

export const CoreIcon = (props: CoreIconProps) => {
  const { src: _src, ...rest } = props;
  const src = typeof _src === 'object' ? _src.src : _src;

  return (
    <SVG
      {...rest}
      src={src}
      loader={
        <span
          style={{
            width: `${props.width ?? DEFAULT_WIDTH}px`,
            height: `${props.height ?? DEFAULT_HEIGHT}px`,
          }}
        />
      }
      style={{
        minWidth: `${props.width ?? DEFAULT_WIDTH}px`,
        ...props.style,
      }}
    />
  );
};

export type IconProps = Omit<CoreIconProps, 'src'>;
